import Moment from "moment";
import axios from "axios"
import {getHours, getMonth, getDate, getDay} from 'date-fns'
let week = [6,0,1,2,3,4,5]
export default class TagFunctions {
  static evAuthenticationPush = async (platform) => {
    let country;
    try {
      let res = await axios.get("https://extreme-ip-lookup.com/json/?key=LSrYRa4bab9N0BLiYnzF")
      country = res.data.country
    } catch (e) {
      country = undefined;
    }
    let digData = {
      event: "authentication",
      userData: {
        userId: localStorage.getItem('userId') || undefined,
        userInfo: {
          age: Number(localStorage.getItem('ageUser'))?Number(localStorage.getItem('ageUser')):undefined,
          birthYear: Number(localStorage.getItem('ageUserBirthYear'))?Number(localStorage.getItem('ageUserBirthYear')):undefined,
          country: localStorage.getItem('ageUserCountry')?localStorage.getItem('ageUserCountry'):'NA'
        },
        profile: {
          loginType: localStorage.getItem('network')?localStorage.getItem('network'):'Normal',
          platform: 'web',
        }
      },
    };
    window.dataLayer.push(digData);
  };
  static evPageViewPush = async () => {
    let lang = window.navigator.language.toLowerCase().startsWith('es') ? 'ESP' : 'ENG'
    sessionStorage.setItem('test-sesion', '5-6-2021');
    let country;
    const res = await fetch("https://extreme-ip-lookup.com/json/", {
      method: "GET"
    })
      .then(res => res.json())
      .then(res => {
        country = res.country;
      })
      .catch(function() {
        console.log(`Can"t connect to backend try latter`);
        country = "NA";
      });
    // console.log(`res`, res);
    const today = Moment();
    var loc = window.location;
    var pathName =
      loc.pathname === "/"
        ? "Home"
        : loc.pathname.substring(1, loc.pathname.length);
    var network =
      localStorage.getItem("network") !== null
        ? (network = localStorage.getItem("network"))
        : (network = "Normal");
    let cookies = document.cookie.split(";");
    let birthdate;
    if (cookies.length) {
      let aux;
      cookies.forEach(e => {
        aux = e.split("=");
        if (aux[0].includes("agegate_tecate_com_mx")) birthdate = Moment(aux[1], "DD-MM-YYYY");
        else birthdate = today;
      });
    }

    let digitalData = {
      event: "evPageView",
      version: "1.0",
      page: {
        pageInfo: {
          hostName: `${loc.origin}`,
          pageName: `${pathName}`,
          currentURL: `${loc.href}`
        }
      },
      user: {
        profile: {
          userWeekDay: today.day(),
          userMonthDay: today.date(),
          userMonth: today.month(),
          userTime: today.hour(),
          languajeUser: lang,
          profileInfo: {
            ageUserBirthYear: Number(localStorage.getItem('ageUserBirthYear'))?Number(localStorage.getItem('ageUserBirthYear')):'NA',
            ageUser: Number(localStorage.getItem('ageUser'))?Number(localStorage.getItem('ageUser')):'NA',
            ageUserCountry: localStorage.getItem('ageUserCountry')?localStorage.getItem('ageUserCountry'):'NA',
            userId: localStorage.getItem("userId") || 'NA',
          },
          social: {
            network: localStorage.getItem('network')?localStorage.getItem('network'):'Normal'
          }
        }
      }
    };
    window.dataLayer.push(digitalData);
  };
  getPathName = pathName => {
    if (pathName === "/" || pathName === "home") return "Home";
  };
  static evAgeGatePush = (action, error) => {
    if (action && error && error != "") {
      window.dataLayer.push({
        action: `${action}`,
        error: `${error}`,
        event: "evAgeGate"
      });
    }
  };
  // Click over options
  static evClickOptionsPush = (action) => {
    window.dataLayer.push({
      actionClick: `${action}`,
      event: "evClickOptions"
    });
  };
  // Social Network
  static evSocialNetworkPush = (socialNetwork, action) => {
    window.dataLayer.push({
      socialNetworkName: `${socialNetwork}`,
      actionSocialNetwork: `${action}`,
      event: "evSocialNetwork"
    });
  };
  static evib2cOutboundlinkPush = name => {
    window.dataLayer.push({
      nameOutboundLinkib2C: `${name}`,
      event: "evib2cOutboundlink"
    });
  };
  static evVideoPush = (name, action, quartile, time) => {
    window.dataLayer.push({
      videoName: `${name}`,
      videoAction: `${action}`,
      videoQuartile: `${quartile}`,
      videototalTime: `${time}`,
      event: "evVideo"
    });
  };
  static evRegisterPush = (action) => {
    window.dataLayer.push({
      registerAction: `${action}`,
      event: "evRegister"
    });
  };
  // Events GA4
  static user_interactionPush = (action, element, section) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "user_interaction",
      eventParams: {
        action: `${action}`,
        element: `${element}`,
        section: `${section}`
      }
    });
  };
  static form_interactionPush = (name, action) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "form_interaction",
      eventParams: {
        form_name: "age gate",
        form_field: `${name}`,
        form_action: `${action}`,
        section: "login"
      }
    });
  };
  static form_sendPush = (name, element) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "form_send",
      eventParams: {
        form_name: "age gate",
        form_field: `${name}`,
        element: `${element}`,
        section: "login"
      }
    });
  };
  static methodPush = (method) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "login",
      eventParams: {
        method: `${method}`
      }
    });
  };
}

